// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tlm-checkout-devices-subscription-change-selected-icon[data-v-fec81b02]{align-items:center;border:1px solid var(--v-info-base);display:flex;height:24px;justify-content:center;position:absolute;right:8px;top:8px;width:24px}.tlm-checkout-devices-subscription-change-selected-icon svg[data-v-fec81b02]{color:var(--v-success-base);font-size:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
